import { jsx, jsxs } from "react/jsx-runtime";
import { components } from "react-select";
import { vars } from "../../themes/vars.css.mjs";
import { Box } from "../Box/Box.mjs";
import clsx from "clsx";
import { TextContext } from "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconExpandMore } from "../icons/IconExpandMore/IconExpandMore.mjs";
import { Text } from "../Text/Text.mjs";
import { Button } from "../Button/Button.mjs";
import { SelectFieldInternalList } from "../DropdownList/DropdownInternalList.mjs";
import { SelectFieldList } from "../DropdownList/DropdownList.mjs";
import { useTheme } from "../ThemeProvider/ThemeContext.mjs";
import { VanillaThemeContainer } from "../ThemeProvider/VanillaThemeContainer.mjs";
import { zIndexes } from "../../css/zIndex.mjs";
import { control, singleValue, label, input, menu } from "./Dropdown.css.mjs";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Hidden/Hidden.css.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Accordion/AccordionContext.mjs";
import { Columns } from "../Columns/Columns.mjs";
import { Column } from "../Column/Column.mjs";
import { Inline } from "../Inline/Inline.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "./Dropdown.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../private/defaultTextProps.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import "../RadioBar/RadioBarContext.mjs";
import "../RadioBar/RadioBar.css.mjs";
import "../RadioBar/RadioBar.mjs";
function Control(props) {
  return /* @__PURE__ */ jsx(
    components.Control,
    {
      ...props,
      className: clsx(
        props.className,
        control({
          isReadOnly: props.selectProps.isReadOnly || false
        })
      )
    }
  );
}
function ValueContainer(props) {
  return /* @__PURE__ */ jsx(components.ValueContainer, { ...props });
}
function SingleValue({ isDisabled, data }) {
  const showTertiary = data.tertiaryLabel;
  return /* @__PURE__ */ jsx(Box, { width: "full", className: singleValue, children: showTertiary ? /* @__PURE__ */ jsxs(Columns, { space: "none", align: "left", children: [
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Inline, { align: "left", space: "xsmall", children: [
      /* @__PURE__ */ jsx(Box, { className: label.primaryLabel, children: /* @__PURE__ */ jsx(Text, { maxLines: 1, tone: isDisabled ? "disabled" : "neutral", children: data.label }) }),
      /* @__PURE__ */ jsx(Box, { className: label.secondaryLabel, children: /* @__PURE__ */ jsx(Text, { maxLines: 1, tone: isDisabled ? "disabled" : "positive", children: data.secondaryLabel }) })
    ] }) }),
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Box, { marginRight: "medium", children: /* @__PURE__ */ jsx(Inline, { align: "right", space: "none", children: /* @__PURE__ */ jsx(Text, { maxLines: 1, tone: isDisabled ? "disabled" : "neutral", weight: "medium", children: data.tertiaryLabel }) }) }) })
  ] }) : /* @__PURE__ */ jsx(Text, { tone: isDisabled ? "disabled" : "neutral", children: data.label }) });
}
function Placeholder(props) {
  return /* @__PURE__ */ jsx(components.Placeholder, { ...props, children: /* @__PURE__ */ jsx(Box, { opacity: 0, children: props.children }) });
}
function DropdownIndicator({ isDisabled }) {
  return /* @__PURE__ */ jsx(Box, { position: "relative", style: { transform: "translateY(-8px)" }, children: /* @__PURE__ */ jsx(IconExpandMore, { tone: isDisabled ? "disabled" : "secondary" }) });
}
function Input(props) {
  return /* @__PURE__ */ jsx(components.Input, { ...props, className: input });
}
function Menu(props) {
  return /* @__PURE__ */ jsx(components.Menu, { ...props, className: menu, children: props.children });
}
function MenuList(props) {
  return /* @__PURE__ */ jsx(components.MenuList, { ...props, children: /* @__PURE__ */ jsxs(Box, { onClick: (e) => e.nativeEvent.stopPropagation(), children: [
    props.isMulti && props.selectProps.showMultiSelectBulkActions && /* @__PURE__ */ jsx(Box, { padding: "xxsmall", children: /* @__PURE__ */ jsx(Box, { padding: "none", display: "flex", alignItems: "flexEnd", children: /* @__PURE__ */ jsx(
      Button,
      {
        variant: "transparent",
        onClick: () => {
          const nonDisabledOptions = props.selectProps.options.filter(
            (o) => !o.disabled
          );
          props.hasValue ? props.clearValue() : props.selectProps.onChange(nonDisabledOptions, {
            action: "select-option",
            option: nonDisabledOptions
          });
        },
        internal_unsafe__bypassUsePress: true,
        children: props.hasValue ? props.selectProps.clearAllButtonLabel : props.selectProps.selectAllButtonLabel
      }
    ) }) }),
    /* @__PURE__ */ jsx(SelectFieldInternalList, { children: props.children })
  ] }) });
}
function Option(props) {
  return /* @__PURE__ */ jsx(components.Option, { ...props, children: /* @__PURE__ */ jsx(
    SelectFieldList,
    {
      ...props.data,
      size: "medium",
      onClick: () => props.isSelected && !props.selectProps.isMulti ? props.setValue(null, "deselect-option") : props.selectOption(props.data),
      isFocused: props.isFocused,
      isSelected: props.isSelected,
      ignoreTabIndex: true,
      target: void 0
    }
  ) });
}
function MenuPortal(props) {
  const { vanillaTheme } = useTheme();
  return /* @__PURE__ */ jsx(components.MenuPortal, { ...props, children: /* @__PURE__ */ jsx(TextContext.Provider, { value: null, children: /* @__PURE__ */ jsx(VanillaThemeContainer, { theme: vanillaTheme, setDefaultTextTones: true, children: props.children }) }) });
}
function NoOptionsMessage(props) {
  return /* @__PURE__ */ jsx(Box, { padding: "small", children: /* @__PURE__ */ jsx(Box, { padding: "none", alignItems: "center", children: /* @__PURE__ */ jsx(Box, { color: "secondary", children: props.children }) }) });
}
const IndicatorSeparator = null;
function styles() {
  return {
    control: ({ ...provided }) => ({
      ...provided,
      background: "transparent",
      borderWidth: 0
    }),
    menuPortal: (provided) => ({
      ...provided,
      background: vars.backgroundColor.body,
      zIndex: zIndexes.modal
    }),
    valueContainer: ({ padding, ...provided }) => ({ ...provided }),
    input: ({ margin, paddingBottom, paddingTop, color, ...provided }) => ({
      ...provided
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: vars.space.none,
      background: vars.backgroundColor.body,
      left: vars.space.none,
      zIndex: 2
    }),
    menuList: ({ paddingTop, paddingBottom, ...provided }) => ({
      ...provided,
      background: vars.backgroundColor.body
    }),
    option: (provided) => ({
      ...provided,
      cursor: "pointer",
      background: vars.backgroundColor.body,
      padding: vars.space.none,
      color: vars.foregroundColor.neutral,
      "& :hover": { background: vars.backgroundColor.formAccentSoftHover },
      "& div[role=link]": {
        "& :hover": {
          background: vars.backgroundColor.formAccentSoftHover
        }
      }
    }),
    container: ({ ...provided }) => ({
      ...provided,
      width: "100%"
    })
  };
}
const selectComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Control,
  DropdownIndicator,
  IndicatorSeparator,
  Input,
  Menu,
  MenuList,
  MenuPortal,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
  styles
}, Symbol.toStringTag, { value: "Module" }));
export {
  selectComponents,
  styles
};
